import { render, staticRenderFns } from "./BoFieldGroup.vue?vue&type=template&id=5d8b03c2&"
import script from "./BoFieldGroup.vue?vue&type=script&lang=js&"
export * from "./BoFieldGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports